<template>
	<div v-if="!dataSame" class="finance-table">
		<egranty-section-divider
			icon="attach_money"
			text="Budżet"
		/>

		<costs-calculated-headers/>

		<v-layout row wrap>
			<v-flex d-flex xs6>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>A. Koszty administracyjne</h2>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-0">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>

		</v-layout>

		<div>
			<div row v-for="cost in normalizedAdministrative"
				:key="(cost.old ? cost.old.serialNumber: '') + '' + (cost.new? cost.new.serialNumber : '')">
				<v-layout row>

					<compare-costs-calculated-single-cost old v-if="cost.old" :cost="cost.old" :other-cost="cost.new"
					/>
				</v-layout>
				<v-layout row>
					<compare-costs-calculated-single-cost v-if="cost.new" :cost="cost.new" :other-cost="cost.old"
					/>
				</v-layout>

			</div>
		</div>

		<v-layout>
			<v-flex d-flex xs6>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>P. Koszty programowe</h2>
					</v-card-text>
				</v-card>

			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-0">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs2>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong></strong></v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div>
			<div v-for="action in normalizedCosts" :key="'action' + action.serialNumber">
				<compare-costs-calculated-single-action old :other-cost="action.new" :cost="action.old"
					v-if="action.old"
				/>
				<compare-costs-calculated-single-action :other-cost="action.old" :cost="action.new" v-if="action.new"
				/>
				<div>
					<div v-for="cost in action.costs"
						:key="(cost.old ? cost.old.serialNumber: '') + '' + (cost.new? cost.new.serialNumber : '')">
						<v-layout row>

							<compare-costs-calculated-single-cost :serial-number="action.serialNumber" old
								v-if="cost.old" :cost="cost.old"
								:other-cost="cost.new"
							/>
						</v-layout>
						<v-layout row>
							<compare-costs-calculated-single-cost :serial-number="action.serialNumber" v-if="cost.new"
								:cost="cost.new"
								:other-cost="cost.old"
							/>
						</v-layout>

					</div>
				</div>
			</div>
		</div>

		<v-layout v-if="false">
			<v-flex d-flex xs7>
				<v-card color="grey darken-1" dark>
					<v-card-text>
						<h2>Razem</h2>
					</v-card-text>
				</v-card>

			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-0">
					<v-card-text><strong>{{formatMoney(administrativeTotalPrice() + actionsTotalPrice())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong>{{formatMoney(administrativeFromDotation() + actionsFromDotation())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong>{{formatMoney(administrativeFromOther() + actionsFromOther())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong>{{formatMoney(administrativeFromOwnHuman() + actionsFromOwnHuman())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex d-flex xs1>
				<v-card color="grey lighten-1">
					<v-card-text><strong>{{formatMoney(administrativeFromOwnFinancial() +
						actionsFromOwnFinancial())}}</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<br>
		<br>
	</div>
</template>

<script>
	import CostsCalculatedHeaders from "./CostsCalculatedHeaders";
	import CompareCostsCalculatedSingleCost from "./CompareCostsCalculatedSingleCost";
	import CompareCostsCalculatedSingleAction from "./CompareCostsCalculatedSingleAction";
	import {Numbers} from "@/utils/Numbers";
	import EgrantySectionDivider from "../../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "CompareCostsCalculatedTable",

		components: {
			EgrantySectionDivider, CompareCostsCalculatedSingleAction, CompareCostsCalculatedSingleCost, CostsCalculatedHeaders},

    mixins: [Numbers],

		computed: {
			dataSame () {
        let idKeyReplacer = (key, value) => {
          if (key === 'id') {
            return undefined;
          }
          return value;
        };

        let oldActionsCopy = JSON.parse(JSON.stringify(this.oldActions, idKeyReplacer));
        let actionsCopy = JSON.parse(JSON.stringify(this.actions, idKeyReplacer));

				return JSON.stringify(oldActionsCopy) === JSON.stringify(actionsCopy) &&
					JSON.stringify(this.oldAdministrative) === JSON.stringify(this.administrative);
			},

			normalizedCosts () {
				let result = [];
				for (let action of this.oldActions) {
					let toAdd = {};
					toAdd.serialNumber = action.serialNumber;
					toAdd.old = {};
					toAdd.old.serialNumber = action.serialNumber;
					toAdd.old.name = action.action;
					toAdd.costs = [];
					for (let cost of action.costs) {
						toAdd.costs.push({old: this.normalizeCost(cost)});
					}

					toAdd.old.fromDotation = this.totalFromAction(toAdd, x => x.old ? x.old.fromDotation : 0);
					toAdd.old.fromOwnHuman = this.totalFromAction(toAdd, x => x.old ? x.old.fromOwnHuman : 0);
					toAdd.old.fromOwnFinancial = this.totalFromAction(toAdd, x => x.old ? x.old.fromOwnFinancial : 0);
					toAdd.old.fromOther = this.totalFromAction(toAdd, x => x.old ? x.old.fromOther : 0);

					toAdd.old.totalPrice = toAdd.old.fromDotation +
						toAdd.old.fromOwnFinancial +
						toAdd.old.fromOwnHuman +
						toAdd.old.fromOther;

					result.push(toAdd);
				}

        for (let action of this.actions) {
					let toAdd = {};

					if (result.find(x => x.serialNumber === action.serialNumber)) {
						toAdd = result.find(x => x.serialNumber === action.serialNumber);
					} else {
						toAdd.serialNumber = action.serialNumber;
						result.push(toAdd);
					}

					toAdd.new = {};
					toAdd.new.serialNumber = action.serialNumber;
					toAdd.new.name = action.action;
					if (toAdd.costs === undefined) {
						toAdd.costs = [];
					}
					for (let cost of action.costs) {
						if (toAdd.costs.find(x => x.old && x.old.serialNumber === cost.serialNumber)) {
							(toAdd.costs.find(x => x.old.serialNumber === cost.serialNumber)).new = this.normalizeCost(cost);
						} else {
							toAdd.costs.push({new: this.normalizeCost(cost)});
						}
					}
					toAdd.new.fromDotation = this.totalFromAction(toAdd, x => x.new ? x.new.fromDotation : 0);
					toAdd.new.fromOwnHuman = this.totalFromAction(toAdd, x => x.new ? x.new.fromOwnHuman : 0);
					toAdd.new.fromOwnFinancial = this.totalFromAction(toAdd, x => x.new ? x.new.fromOwnFinancial : 0);
					toAdd.new.fromOther = this.totalFromAction(toAdd, x => x.new ? x.new.fromOther : 0);

					toAdd.new.totalPrice = toAdd.new.fromDotation +
						toAdd.new.fromOwnFinancial +
						toAdd.new.fromOwnHuman +
						toAdd.new.fromOther;
				}

				return result;
			},

			normalizedAdministrative () {
				let result = [];

				for (let administrative of this.oldAdministrative) {
					result.push({old: this.normalizeCost(administrative)});
				}

				for (let administrative of this.administrative) {
					if (!result.find(x => x.old && x.old.serialNumber === administrative.serialNumber)) {
						result.push({new: this.normalizeCost(administrative)});
					} else {
						result.find(x => x.old && x.old.serialNumber === administrative.serialNumber).new = this.normalizeCost(administrative);
					}
					//	result.push(this.normalizeCost(administrative));
				}

				return result;
			},

		},


		methods: {

			status (action) {
				if (!action.oldName) {
					return "(Nowe)";
				}
				if (!action.newName) {
					return "(Usunięte)";
				}
				return "";
			},

			statusColor (action) {
				if (!action.oldName) {
					return "green";
				}
				if (!action.newName) {
					return "red";
				}
				return "grey";
			},

			normalizeCost (cost) {
				let result = {
					serialNumber: cost.serialNumber,
					name: cost.name,
					unitsCount: cost.unitsCount,
					pricePerUnit: cost.pricePerUnit,
					measureType: cost.measureType,
					totalPrice: 0,
					fromDotation: 0,
					fromOther: 0,
					fromOwnHuman: 0,
					fromOwnFinancial: 0,
				};

				for (let division of cost.costDivisions) {
					if (division.type === 'z dotacji') {
						result.fromDotation += division.totalPrice;
						continue;
					}
					if (division.type === 'wkład osobowy') {
						result.fromOwnHuman += division.totalPrice;
						continue;
					}
					if (division.type === 'wkład rzeczowy') {
						result.fromOwnFinancial += division.totalPrice;
						continue;
					}
					result.fromOther += division.totalPrice;
				}
				result.totalPrice = result.fromDotation + result.fromOther + result.fromOwnFinancial + result.fromOwnHuman;
				return result;
			},

			totalFromActions (getter) {
				let result = 0;
				for (let action of this.normalizedCosts) {
					for (let cost of action.costs) {
						result += getter(cost);
					}
				}
				return result;
			},

			totalFromAdministrative (getter) {
				let result = 0;
				for (let cost of this.normalizedAdministrative) {
					result += getter(cost);
				}
				return result;
			},

			totalFromAction (action, getter) {
				let result = 0;
				for (let cost of action.costs) {
					result += getter(cost);
				}
				return result;
			},

			administrativeTotalPrice () {
				return this.totalFromAdministrative(x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial);
			},

			administrativeFromDotation () {
				return this.totalFromAdministrative(x => x.fromDotation);
			},

			administrativeFromOwnFinancial () {
				return this.totalFromAdministrative(x => x.fromOwnFinancial);
			},

			administrativeFromOwnHuman () {
				return this.totalFromAdministrative(x => x.fromOwnHuman);
			},

			administrativeFromOther () {
				return this.totalFromAdministrative(x => x.fromOther);
			},

			actionsTotalPrice () {
				return this.totalFromActions(x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial);
			},

			actionsFromDotation () {
				return this.totalFromActions(x => x.fromDotation);
			},

			actionsFromOwnFinancial () {
				return this.totalFromActions(x => x.fromOwnFinancial);
			},

			actionsFromOwnHuman () {
				return this.totalFromActions(x => x.fromOwnHuman);
			},

			actionsFromOther () {
				return this.totalFromActions(x => x.fromOther);
			},

			actionTotalPrice (action) {
				return this.totalFromAction(action, x => x.fromDotation + x.fromOther + x.fromOwnHuman + x.fromOwnFinancial);
			},

			actionFromDotation (action) {
				return this.totalFromAction(action, x => x.fromDotation);
			},

			actionFromOwnFinancial (action) {
				return this.totalFromAction(action, x => x.fromOwnFinancial);
			},

			actionFromOwnHuman (action) {
				return this.totalFromAction(action, x => x.fromOwnHuman);
			},

			actionFromOther (action) {
				return this.totalFromAction(action, x => x.fromOther);
			}

		},

		props: {
			administrative: {},
			actions: {},

			oldAdministrative: {},
			oldActions: {},
		}
	};
</script>

<style scoped>
		.theme--dark .grey.darken-1[data-v-79227a6f] {
		background-color: #0075E2 !important;
	}

	h2 {
		font-size: 14px;
	}
</style>